// @flow

import React from 'react';
import { colors } from '../constants';
import type { IconProps } from './types';

const FileIcon = ({ width = 22, height = 28, className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 22 28"
      width={width}
      height={height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke={colors.mediumGrey}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
      >
        <path d="M5.663 13.434h10.202M5.663 21.684h10.202M5.663 17.684h10.202" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M1.037 26.316h19.491V9.29L13 1.684H1z"
        />
        <path strokeLinejoin="round" d="M12.688 2.129v7.334h8.16" />
      </g>
    </svg>
  );
};

export default FileIcon;
